import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from "@angular/router";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {AuthService} from './login/auth.service';
import {map,take} from "rxjs/operators";
import {Router} from "@angular/router";
import * as fromApp from './store/app.reducer';
import {Store} from "@ngrx/store";
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService,
              private router: Router,
              private store: Store<fromApp.AppState>) {}

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): boolean | UrlTree | Promise<boolean | UrlTree> | Observable<boolean | UrlTree>  {

    const userData = JSON.parse(localStorage.getItem('userData'));
    //TODO WE MIGHT HAVE A BUG HERE.  ENSURE PUBLIC PAGES THAT HAVE DONT REQUIRE AUTH E.G. FORGOT PASSWORD CAN ACCESS
    console.log('userData',userData)
    if (userData==null){
      return this.router.createUrlTree(['/login']);
    }



    const helper = new JwtHelperService();
    const isExpired = helper.isTokenExpired(userData.id_token);
    var current_time = new Date().getTime() / 1000;
    const expirationDate = helper.getTokenExpirationDate(userData.id_token);
    const decodedToken = helper.decodeToken(userData.id_token);
    var time_left = decodedToken['exp'] - current_time;
    console.log('time_left',time_left)
    if (time_left < 60) {
      // TODO get new tkens if about to expire
      //use refresh token to get new keys
      //this.openSnackBar('Your session will expire in 60 seconds','Continue?')
    }
    if (isExpired == true) {
      return this.router.createUrlTree(['/login']);
    }

    //WE ARE USING THE STORE TO CHECK IF THE USER IS LOGGED IN
    return this.store.select('auth').pipe(
      take(1),
       map(
         authState => {
           if (authState.user) {
             return true;
           } else {
             const userData = JSON.parse(localStorage.getItem('userData')); //ALWAYS TRUE HERE.  ONLY ADDED TO FIND BUG
             if (userData) {
               //console.log('here ismy error',userData)
               //WE NEED TO ADD USER DATA BACK TO STORE BECAUSE WE JUST HAD A REFRESH
               //THIS CODE IN  NOT NEEDED BECUASE WE ADDED LOCAL STORAGE TO STORE IN autoLogin
               return true;
             } else{
               return this.router.createUrlTree(['/login']);
             }
           }
         }
       )
         );

    // return this.authService.user.pipe(
    //   take(1),
    //   map(user => {
    //     console.log('AuthGaurd',user);
    //     console.log('ASSSSSSSSSS',!!user)
    //   const isAuth = !!user;
    //   if (isAuth) {
    //     return true;
    //   }
    //   console.log('ARE WE REALLY BEING RESUJREND')
    //   return this.router.createUrlTree(['/login']);
    // }))

  } // end canActivate


}//end class
